import styled from "styled-components";
import { Link } from "react-router-dom";
import { fonts, colors } from "../../../../styles/variables";
import breakpoints from "../../../../styles/breakpoints";

export const CellContainer = styled(Link)`
  display: flex;
  width: 100%;
  flex-wrap: wrap;
  flex-direction: row;
  padding: 20px 0px;
  align-items: flex-start;
  justify-content: flex-start;
  height: auto;
  cursor: pointer;
`;

export const GuidesListImgContainer = styled.div`
  position: relative;
  align-items: center;
  justify-content: center;
  height: 100%;
  ${breakpoints.mdUp} {
    flex: 0.2;
  }
  ${breakpoints.mdDown} {
    flex: 0.4;
  }
`;

export const GuidesListTextContainer = styled.div`
  position: relative;
  align-items: center;
  justify-content: flex-start;
  padding-left: 20px;
  height: 100%;
  ${breakpoints.mdUp} {
    flex: 0.8;
  }
  ${breakpoints.mdDown} {
    flex: 0.6;
  }
`;

export const Description = styled.div`
  &:before {
    font-family: ${fonts.fontBauRegular};
    font-size: 16px;
    color: ${colors.black};
    display: block;
    line-height: 0.9;
  }
  margin-top: 5px;
  margin-bottom: 5px;
`;

export const GuidesListImg = styled.img`
  max-width: 100%;
  max-height: 200px;
  cursor: pointer;
`;

export const SeeMoreTag = styled.span`
  display: inline-block;
  background-color: ${(props) => (props.isGlossary ? colors.purpleThin : colors.successThin)};
  font-family: ${fonts.fontBauRegular};
  font-weight: bold;
  font-size: 11px;
  color: ${colors.black};
  display: block;
  line-height: 0.7;
  padding: 8px 10px;
  border-radius: 13px;
  cursor: pointer;
  text-transform: uppercase;
`;

export const SeeMoreTagSpan = styled.span`
  display: inline-block;
  margin-bottom: 5px;
  margin-top: 9px;
`;

export const StyledTitle = styled.h3`
  font-size: 35px;
  line-height: 1.2;
  letter-spacing: -0.025em;
  -webkit-letter-spacing: -0.025em;
  color: ${colors.black};
  font-family: ${fonts.fontInterstateBlackCompressed};
  word-break: break-word;
  ${breakpoints.smDown} {
    font-size: 30px;
  }
  margin-bottom: 0;
`;
